import Collapse from 'react-bootstrap/Collapse';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { KPCuspalPosition } from './KPCuspalPosition';
import { KPPlanetaryPosition } from './KPPlanetaryPosition';
import { RashiChart } from '../Basic/RashiChart';
import { axiosGetWithHeader } from '../../Common/axios';
import { useEffect, useState } from 'react';

export function KPBasicChart ({menuArray,userData,clientData}) {
  const [birthChartType, setBirthChartType] = useState('0');
  const [birthHouseData, setBirthHouseData] = useState([]);

  useEffect(() => {
    axiosGetWithHeader("/chart/birthchart/"+userData.id,
      (response)=>{
        setBirthHouseData(response.data.house);
        setBirthChartType(response.data.birthChartType);
      },
      (error)=>{
        console.log(error);
        setBirthHouseData(null);
        setBirthChartType(null);
      }
    );
  }, [userData]);

  return(
    <>
      { userData===null || userData===undefined?<></>:
          <Collapse in={menuArray[1]} className="m-0 p-0 ">
              <Row id="birthChart" className="m-0 p-0">
                  <Col xs={12} md={4} className="p-2 pt-0 m-0 pagebreakportrait">
                    { birthHouseData===null || birthHouseData===undefined || birthHouseData.length===0?<></>:
                    <RashiChart birthHouseData={birthHouseData} userData={userData} clientData={clientData} birthChartType={birthChartType} setBirthChartType={setBirthChartType} kpenabled={true}/>
                    }
                  </Col>
                  <Col xs={12} md={8} className="p-2 pt-0 m-0">
                    <KPCuspalPosition userData={userData} />
                    <KPPlanetaryPosition userData={userData} />
                  </Col>
              </Row>
          </Collapse>
      }
    </>  
    );
}